<template>
    <div>
        <div class="dropdown float-left">
            <button type="button" :disabled="vistaLoading"
                    class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                    id="vistaOptionDropDown" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false"
                    @click="onDropdownOpened">
                <i  style="display: none;" class="fa fa-spin fa-spinner text-grey-darkest vista-project-loader" aria-hidden="true"></i>
                Vista Options <i class="fa fa-caret-down mx-1"></i>
            </button>
            <div class="standard-dropdown dropdown-menu dropdown-menu-right vista-dropdown-menu" aria-labelledby="vistaOptionDropDown">
                <button v-if="canErpCreate" :title="vistaJobsConnectUpdateToolTip" type="button" class="dropdown-item py-2 custom-tooltip"
                        :class="{ 'vista-button-disabled': erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-followup' || project.vista_project_no) }"
                        :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-followup' || project.vista_project_no)"
                        @click.prevent.stop="pushProjectToVista('connect')">
                    Connect/Push to Vista
                </button>
                <button v-if="canErpUpdate" :title="vistaJobsConnectUpdateToolTip" type="button" class="dropdown-item py-2 custom-tooltip"
                        :class="{'vista-button-disabled' :erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-followup' || !project.vista_project_no)}"
                        :disabled="!project.vista_project_no || (erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-followup'))"
                        @click.prevent.stop="pushProjectToVista('update')">
                    Update Job on Vista
                </button>
                <button v-if="canErpSync" :title="vistaJobsSyncToolTip" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party')" @click.prevent="syncProjectFromVista('sync')" >
                    Sync from Vista
                </button>
                <span v-if="!project.vista_project_no">
                    <button title="Please connect/sync project to proceed" type="button" class="dropdown-item py-2 custom-tooltip" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party' || !project.vista_project_no)" @click.prevent="syncProjectFromVista('sync')">
                        Pull Income Cost Summary
                    </button>
                </span>
                <span v-else>
                    <button type="button" class="dropdown-item py-2" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaProjectMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party' || !project.vista_project_no)" @click.prevent="syncProjectVistaInvoice">
                        Pull Income Cost Summary
                    </button>
                </span>

                <button v-if="canErpCreate" :title="vistaWorkOrderToolTip" type="button" class="dropdown-item py-2 custom-tooltip" :style="erpConnectionId&& (!vistaProjectConnectionData.hasVistaWorkOrderMapped || !vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped) ? 'cursor:not-allowed !important; ' : ''" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaWorkOrderMapped || !vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped || project.agave_work_order_no)" @click.prevent.stop="createSMWorkOrder('create-sm-work-order')">
                    Create Work Order
                </button>
                <button v-if="canErpSync" :title="vistaWorkOrderToolTip" type="button" class="dropdown-item py-2 custom-tooltip" :style="erpConnectionId&& (!vistaProjectConnectionData.hasVistaWorkOrderMapped || !vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped)  ? 'cursor:not-allowed !important; ' : ''" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaWorkOrderMapped || !vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped || vistaProjectConnectionData.vistaWorkOrderMappings && vistaProjectConnectionData.vistaWorkOrderMappings.direction === 'one-way-third-party')" @click.prevent.stop="syncVistaWorkOrder('sync-sm-work-order')">
                    Sync Work Order
                </button>

                <button v-if="canErpSync" :title="vistaServiceSiteToolTip" type="button" class="dropdown-item py-2 custom-tooltip" :style="erpConnectionId && (!vistaProjectConnectionData.hasVistaServiceSiteMapped || !vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped) ? 'cursor:not-allowed !important; ' : ''" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaServiceSiteMapped || !vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped)" @click.prevent.stop="syncVistaServiceSite('sync-service-site')">
                    Sync from SM Service Site
                </button>

                <button :title="vistaContractToolTip" type="button" class="dropdown-item py-2 custom-tooltip" :style="(erpConnectionId && (!vistaProjectConnectionData.hasVistaContractMapped || !vistaProjectConnectionData.hasVistaContractFieldsMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party')) ? 'cursor:not-allowed !important; ' : ''" :disabled="erpConnectionId && (!vistaProjectConnectionData.hasVistaContractMapped || !vistaProjectConnectionData.hasVistaContractFieldsMapped || vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party')" @click.prevent.stop="syncContractFromVista('sync-contract')">
                    Sync From Contract
                </button>



            </div>
        </div>
        <!--    Select department and liability template for vista push    -->
        <div class="modal fade" id="vistaDepartmentAndLiabTemplateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ vistaDepartmentAndLiabTemplateModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaDepartmentAndLiabTemplateModal(true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="vistaDepartmentArray.length > 0 || vistaLiabTemplateArray.length > 0">
                        <div class="row container">
                            <label class="mb-0">Select Department</label>
                            <multiselect
                                id="selectVistaDepartment"
                                v-model="selectedVistaDepartment"
                                :options="vistaDepartmentArray"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick a department"
                                :showLabels="false"
                                label="Description"
                                track-by="Department"
                                :preselect-first="false"
                            >
                            </multiselect>
                        </div>
                        <div class="row container mt-2">
                            <label class="mb-0">Select Liability Template</label>
                            <multiselect
                                id="selectVistaLiabTemplate"
                                v-model="selectedVistaLiabTemplate"
                                :options="vistaLiabTemplateArray"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick a liability template"
                                :showLabels="false"
                                label="Description"
                                track-by="KeyID"
                                :preselect-first="false"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="modal-body text-center" v-else>
                        <i class="fa fa-spin fa-spinner text-grey-darkest vista-project-loader" aria-hidden="true"></i>
                        Fetching Vista Department & Liability Templates
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeVistaDepartmentAndLiabTemplateModal(true)">Close</button>
                        <button type="button" class="btn btn-primary" :disabled="vistaDepartmentArray.length == 0 || vistaLiabTemplateArray.length == 0" @click="pushToVista">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="vistaCustomerSelectionModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ vistaCustomerSelectionModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('vistaCustomerSelectionModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
<!--                                <label for="user">Select contact to associate with the Vista Job</label>-->
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="companyContacts"
                                    v-model="selectedCustomerForVistaJob"
                                    label="name"
                                    placeholder="Select Company/Contact"
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
<!--                        <div v-if="selectedCustomerForVistaJob && selectedCustomerForVistaJob.vista_customer_no" class="text-sm mb-3 text-teal">The contact is synced already</div>-->
<!--                        <div v-if="selectedCustomerForVistaJob && !selectedCustomerForVistaJob.vista_customer_no" class="text-sm mb-3 text-teal">Note: You have selected a contact that is not synced with Vista. Clicking on Push will link the contact to an existing customer on Vista if the email domain matches. If email domain does not match, a new customer will be created on Vista.</div>-->

                        <div v-if="selectedCustomerForVistaJob && selectedCustomerForVistaJob.vista_customer_no && vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">Connected to a Vista AR Customer</div>
                        <div v-if="selectedCustomerForVistaJob && !selectedCustomerForVistaJob.vista_customer_no && vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">The selected contact is not connected to a Vista AR customer.</div>
                        <div v-if="selectedCustomerForVistaJob && !selectedCustomerForVistaJob.company.vista_customer_id && !vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">The selected contact/company is not connected to a Vista AR customer.</div>
                        <div v-if="selectedCustomerForVistaJob && selectedCustomerForVistaJob.company.vista_customer_id && selectedCustomerForVistaJob.company.agave_customer_no && !vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">Connected to a Vista AR Customer</div>
                        <div v-if="selectedCustomerForVistaJob && selectedCustomerForVistaJob.vista_customer_no && erpConnectionId !== selectedCustomerForVistaJob.erp_connection_id" class="text-sm mb-3 text-danger mt-3">Company/Contact is synced to different connection. Try changing the connection or selecting other contact</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('vistaCustomerSelectionModal', true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('vistaCustomerSelectionModal');checkCustomerVistaStatus()" :disabled="!this.selectedCustomerForVistaJob || (selectedCustomerForVistaJob.vista_customer_no && erpConnectionId !== selectedCustomerForVistaJob.erp_connection_id)">Select</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateVistaJobModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateVistaJobModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('updateVistaJobModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will replace or update the Vista Job that is synced with this project. Are you sure you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('updateVistaJobModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateJobOnVista">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="syncVistaJobConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ syncVistaJobConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncVistaJobConfirmModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Vista Job.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncVistaJobConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pullJobFromVista()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncJobFromVistaModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncJobFromVistaModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncJobFromVistaModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromVistaStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Vista Job to sync this project with</label>
                                <div v-if="fetchingVistaJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from vista...
                                </div>
                                <multiselect
                                    v-model="selectedVistaJob"
                                    :options="jobsFromVista"
                                    @search-change="onSyncVistaInput"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista job by name or number..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncJobFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaJob" @click.prevent="() => syncFromVistaStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the Vista Job.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncJobFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaJob" @click.prevent="pullJobFromVista">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateVistaSyncedCustomerConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateVistaSyncedCustomerConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('updateVistaSyncedCustomerConfirmModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This company along with the another contact "{{this.syncedOtherCompanyContact ? this.syncedOtherCompanyContact.name : ''}}" is currently linked with Vista
                            customer with customer number "{{this.syncedOtherCompanyContact ? this.syncedOtherCompanyContact.vista_customer_no : ''}}". Would you like to overwrite the contact details on Vista with the contact "{{this.selectedCustomerForVistaJob ? this.selectedCustomerForVistaJob.name : ''}}"?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="updateSyncedCustomerOnVista(false)">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateSyncedCustomerOnVista(true)">Yes</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" tabindex="-1" role="dialog" id="pushProjectWithOutCompanyModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateVistaSyncedCustomerConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('pushProjectWithOutCompanyModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>You have not mapped the company/residential contact field in the ERP settings. Would you like to create a Vista job without a customer associated?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('pushProjectWithOutCompanyModal');pushProjectWithoutCustomer(false);">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('pushProjectWithOutCompanyModal');pushProjectWithoutCustomer(true);">Yes</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal" id="syncJobFromVistaForChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncJobFromVistaForChangeOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncJobFromVistaForChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">This project is currently not synced with Vista. Please select a Job on Vista to sync this with</label>
                                <div v-if="fetchingVistaJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from vista...
                                </div>
                                <multiselect
                                    v-model="selectedVistaJobForChangeOrders"
                                    :options="jobsFromVista"
                                    @search-change="onSyncVistaInput"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista job by name or number..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncJobFromVistaForChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaJobForChangeOrders" @click.prevent="linkJobForChangeOrdersFromVista">Sync</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncVistaChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncVistaChangeOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncVistaChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select Vista Change Order</label>
                                <multiselect
                                    v-model="selectedVistaChangeOrder"
                                    :options="jobChangeOrders"
                                    label="ACO"
                                    track-by="ACO"
                                    :multiple="false"
                                    placeholder="Select Vista Change order..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncVistaChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaChangeOrder" @click.prevent="closeVistaModal('syncVistaChangeOrderModal');openVistaModal('updateVistaSyncedChangeOrderConfirmModal')">Select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateVistaSyncedChangeOrderConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateVistaSyncedChangeOrderConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('updateVistaSyncedChangeOrderConfirmModal')" >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will pull in data from a Change Order in Vista and replace the fields on Followup, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="syncJobChangeOrder()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('updateVistaSyncedChangeOrderConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="createProjectForWorkOrderModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ createProjectForWorkOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeVistaModal('createProjectForWorkOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This project is not connected to a job on Vista yet. Push as a Job First?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('createProjectForWorkOrderModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('createProjectForWorkOrderModal');pushProjectToVista();">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="createProjectForWorkOrderTypeModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ createProjectForWorkOrderTypeModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('createProjectForWorkOrderTypeModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label class="mb-0">Select work order type</label>
                                <multiselect
                                    v-model="workOrderType"
                                    :options="workOrderTypes"
                                    label="label"
                                    track-by="id"
                                    :multiple="false"
                                    placeholder="Select work order type..."
                                    :closeOnSelect="true"
                                ></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('createProjectForWorkOrderTypeModal', true)">Cancel</button>
                        <button v-if="project.vista_work_order_customer_no && project.vista_service_site && project.vista_service_site_description && project.vista_service_center" type="button" class="btn btn-primary" @click.prevent.stop="pushVistaWorkOrderCustomerExistCreateStore()">Continue</button>
                        <button v-else type="button" class="btn btn-primary" @click.prevent.stop="pushWorkOrderToVistaModal()">Next</button>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal" tabindex="-1" role="dialog" id="createProjectContactsForWorkOrderModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ createProjectContactsForWorkOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('createProjectContactsForWorkOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="!checkJobChangeOrdersSMContact && !checkNoSMCustomerFound">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
<!--                                <label class="mb-0" v-if="syncVistaWorkOrderCheck">Select the Followup project contact you would like to link the Work Order to</label>-->
                                <multiselect
                                    v-model="projectContactSelected"
                                    :options="companyContacts"
                                    label="name"
                                    track-by="id"
                                    :multiple="false"
                                    :placeholder="(syncVistaWorkOrderCheck)? 'Select Company/Contact':'Select Company/Contact'"
                                    :closeOnSelect="true"
                                ></multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div v-if="projectContactSelected && projectContactSelected.vista_customer_no && !checkNoSMCustomerFound && vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">Connected to a Vista AR Customer</div>
                                <div v-if="projectContactSelected && !projectContactSelected.vista_customer_no && !checkNoSMCustomerFound && vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">The selected contact is not connected to a Vista AR customer.</div>
                                <div v-if="projectContactSelected && !projectContactSelected.company.vista_customer_id && !checkNoSMCustomerFound && !vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">The selected contact/company is not connected to a Vista AR customer.</div>
                                <div v-if="projectContactSelected && projectContactSelected.company.vista_customer_id && projectContactSelected.company.agave_customer_no && !vistaProjectConnectionData.checkCompanyContactMapping" class="text-sm mb-3 text-teal">Connected to a Vista AR Customer</div>
                            </div>
                        </div>
                        <div v-if="checkJobChangeOrdersSMContact && !checkNoSMCustomerFound" class="spinner text-lg text-teal">
                            <i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>  Checking AR customer, and there IS a corresponding SM customer...
                        </div>
                        <div v-if="checkNoSMCustomerFound && !checkJobChangeOrdersSMContact" class="text-lg text-teal">
                            There is no SM Customer for the selected AR customer. Please create one and try again.
                        </div>

                    </div>
                    <div class="modal-footer" v-if="!checkNoSMCustomerFound">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('createProjectContactsForWorkOrderModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushProjectContactToVista">Next</button>
                    </div>
                    <div class="modal-footer" v-if="checkNoSMCustomerFound">
                        <button type="button" class="btn btn-outline-danger" @click.prevent="closeVistaModal('createProjectContactsForWorkOrderModal')">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="createProjectForAllServiceSitesModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ createProjectForAllServiceSitesModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('createProjectForAllServiceSitesModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="!checkJobForAllServiceSites && !checkJobForAllServiceSiteForContact">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label class="mb-0">Select service site</label>
                                <multiselect
                                    v-model="selectedServiceSite"
                                    :options="allSMServiceSites"
                                    label="Name"
                                    track-by="ServiceSite"
                                    :multiple="false"
                                    placeholder="Select Service Site..."
                                    :closeOnSelect="true"
                                    @change=""
                                ></multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group" v-if="!syncServiceSiteWithOutWorkOrder && vistaProjectConnectionData.hasVistaServiceSiteMapped && vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="updateProjectServiceSiteCheckBox" name="updateProjectServiceSiteCheckBox" v-model="updateProjectServiceSiteCheckBox">
                                    <label class="form-check-label text-lg text-teal" for="updateProjectServiceSiteCheckBox">
                                        Update project with service site info, as per mapped fields
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="checkJobForAllServiceSites" class="spinner text-lg text-teal">
                            <i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>  Fetching Service Sites....
                        </div>
                        <div v-if="checkJobForAllServiceSiteForContact && allSMServiceSites.length === 0" class="text-lg text-teal">
                            No service site was found for the linked SM customer
                        </div>

                    </div>
                    <div class="modal-footer" v-if="!checkJobForAllServiceSites && !checkJobForAllServiceSiteForContact">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('createProjectForAllServiceSitesModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pushVistaWorkOrderCustomerServiceStore(); closeVistaModal('createProjectForAllServiceSitesModal');">Continue</button>
                    </div>
                    <div class="modal-footer" v-if="checkJobForAllServiceSiteForContact">
                        <button type="button" class="btn btn-outline-danger" @click.prevent="closeVistaModal('createProjectForAllServiceSitesModal')">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="createProjectForAllWorkOrdersModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ createProjectForAllWorkOrdersModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('createProjectForAllWorkOrdersModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="!checkJobForAllWorkOrders && !checkJobForAllWorkOrdersForContact">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label class="mb-0">This project is not linked to a vista Work Order. Select an existing Vista Work Order</label>
                                <multiselect
                                    v-model="selectedWorkOrder"
                                    :options="allSMWorkOrders"
                                    label="Name"
                                    track-by="ServiceSite"
                                    :multiple="false"
                                    placeholder="Select Work Order..."
                                    :closeOnSelect="true"
                                    @change=""
                                ></multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group" v-if="vistaProjectConnectionData.hasVistaServiceSiteMapped && vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="updateProjectServiceSiteCheckBox" name="updateProjectServiceSiteCheckBox" v-model="updateProjectServiceSiteCheckBox">
                                    <label class="form-check-label text-lg text-teal" for="updateProjectServiceSiteCheckBox">
                                        Update project with service site info, as per mapped fields
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="checkJobForAllWorkOrders" class="spinner text-lg text-teal">
                            <i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>  Fetching Work Order....
                        </div>
                        <div v-if="checkJobForAllWorkOrdersForContact && allSMWorkOrders.length === 0" class="text-lg text-teal">
                            No work order was found for the linked SM customer
                        </div>

                    </div>
                    <div class="modal-footer" v-if="!checkJobForAllWorkOrders && !checkJobForAllWorkOrdersForContact">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('createProjectForAllWorkOrdersModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="syncVistaWorkOrderCustomerServiceStore(); closeVistaModal('createProjectForAllWorkOrdersModal');">Continue</button>
                    </div>
                    <div class="modal-footer" v-if="checkJobForAllWorkOrdersForContact">
                        <button type="button" class="btn btn-outline-danger" @click.prevent="closeVistaModal('createProjectForAllWorkOrdersModal')">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="searchVRContactsForWorkOrderModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ searchVRContactsForWorkOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('searchVRContactsForWorkOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label class="mb-0">The selected contact is not connected to a Vista AR customer yet. Please select a Vista AR customer to connect the contact to.</label>
                                <multiselect
                                    v-model="arCustomerVistaSelected"
                                    :options="arCustomersVista"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista AR customers"
                                    :closeOnSelect="true"
                                    @search-change="searchARCustomers"
                                    :loading="isARCustomerLoading"
                                ></multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('searchVRContactsForWorkOrderModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="linkARCustomerToSelectedContact">Continue</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncProjectForServiceSiteModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ syncProjectForServiceSiteModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeVistaModal('syncProjectForServiceSiteModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>WARNING! - This will update the Followup project with info from the linked service site, based on the mapped fields</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncProjectForServiceSiteModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('syncProjectForServiceSiteModal');syncProjectToServiceSite();">Sync</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncProjectForWorkOrderModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ syncProjectForWorkOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeVistaModal('syncProjectForWorkOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="this.updateProjectServiceSiteCheckBox">This will update the project with info from the selected work order & service site</p>
                        <p v-else>This will update the Followup project with info from the selected work order</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncProjectForWorkOrderModal')">Cancel</button>
                        <button type="button" class="btn btn-danger" @click.prevent="closeVistaModal('syncProjectForWorkOrderModal');syncProjectToWorkOrder();">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncProjectForWorkOrderExistModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ syncProjectForWorkOrderExistModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeVistaModal('syncProjectForWorkOrderExistModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will update the followup project with current info on the linked Vista Work Order</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncProjectForWorkOrderExistModal')">Cancel</button>
                        <button type="button" class="btn btn-danger" @click.prevent="closeVistaModal('syncProjectForWorkOrderExistModal');syncProjectToWorkOrderExist();">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncContractFromVistaModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncContractFromVistaModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncContractFromVistaModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncContractFromVistaStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Vista Contract to sync this project with</label>
                                <div v-if="fetchingVistaContracts" class="spinner text-sm text-teal">
                                    Fetching contract from vista...
                                </div>
                                <multiselect
                                    v-model="selectedVistaContract"
                                    :options="contractsFromVista"
                                    @search-change="onContractSyncVistaInput"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista contract by name or number..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncContractFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaContract" @click.prevent="() => syncContractFromVistaStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the Vista contract.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncContractFromVistaModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaContract" @click.prevent="pullContractFromVista">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="syncVistaContractConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ syncVistaContractConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncVistaContractConfirmModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Vista Contract.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('syncVistaContractConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pullContractFromVista()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncContractFromVistaForChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ syncContractFromVistaForChangeOrderModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('syncContractFromVistaForChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">This project change order is currently not synced with Vista. Please select a Contract on Vista to sync this with</label>
                                <div v-if="fetchingVistaJobs" class="spinner text-sm text-teal">
                                    Fetching contracts from vista...
                                </div>
                                <multiselect
                                    v-model="selectedVistaContractForChangeOrders"
                                    :options="contractsFromVista"
                                    @search-change="onContractSyncVistaInput"
                                    label="label"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Vista contract by name or number..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('syncContractFromVistaForChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedVistaContractForChangeOrders" @click.prevent="syncChangeOrderFromContract">Sync</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="updateVistaSyncedContractChangeOrderConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">{{ updateVistaSyncedContractChangeOrderConfirmModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('updateVistaSyncedContractChangeOrderConfirmModal')" >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will pull in data from a Contract in Vista and replace the fields on Followup, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="syncChangeOrderFromContract()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeVistaModal('updateVistaSyncedContractChangeOrderConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="selectConnectionForVista" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">{{ vistaConnectionSelectionModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeVistaModal('selectConnectionForVista', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select a Vista Connection to Proceed</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="processedErpConnections"
                                    v-model="selectedConnection"
                                    label="name"
                                    placeholder="Search and select a connection..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                    @input="fetchVistaProjectData"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <!-- Error Message Display -->
                        <div v-if="vistaErrorMessage" class="col-12">
                            <p class="text-danger">Note: {{ vistaErrorMessage }}</p>
                        </div>

                        <div v-if="erpConnectionError && erpPushProjectInitiatedBySalesStatus" class="col-12">
                            <p class="text-danger">Note: {{ erpConnectionError }}</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeVistaModal('selectConnectionForVista', true)">Cancel</button>
                        <button v-if="erpPushProjectInitiatedBySalesStatus && this.selectedVistaAction !== 'create-sm-work-order'"
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="pushOrUpdateProjectToVista()"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <!-- Show Loader If API is Fetching -->
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span>
                        </button>
                        <button v-else-if="syncingFromVista || syncingVistaContract || syncingVistaServiceSite || syncingSMWorkOrder"
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="handleVistaSyncSelection()"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <!-- Show Loader If API is Fetching -->
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span>
                        </button>

                        <button v-else-if="syncingChangeOrderFromVista && vistaProjectConnectionData.hasVistaChangeOrderMapped && vistaProjectConnectionData.vistaChangeOrderMappings !== null"
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="syncProjectChangeOrdersFromVista()"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <!-- Show Loader If API is Fetching -->
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span>
                        </button>
                        <button v-else-if="syncingChangeOrderFromVista && vistaProjectConnectionData.hasVistaContractChangeOrderMapped && vistaProjectConnectionData.vistaContractChangeOrderMappings !== null"
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="syncProjectChangeOrdersFromVistaContract()"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <!-- Show Loader If API is Fetching -->
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>
                            <span v-else>Next</span>
                        </button>

                        <button v-else-if="this.selectedVistaAction === 'create-sm-work-order'"
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="createSMWorkOrder('create-sm-work-order')"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>

                            <span v-else>Next</span>
                        </button>
                        <button v-else
                                type="button"
                                class="btn btn-primary flex items-center justify-center"
                                :class="{ 'cursor-not-allowed': (!this.selectedConnection || !!vistaErrorMessage || loadingVistaData) }"
                                @click.prevent="pushOrUpdateProjectToVista(null)"
                                :disabled="!this.selectedConnection || !!vistaErrorMessage || loadingVistaData">

                            <!-- Show Loader If API is Fetching -->
                            <span v-if="loadingVistaData">
                                <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                            </span>

                            <span v-else>Next</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
export default {
    name: 'project-vista',
    components: {Multiselect},
    props: ['project', 'companyContacts', 'vistaJobNumberCustomFieldId', 'projectSalesStatusState', 'erpPushProjectInitiatedBySalesStatus', 'erpConnections', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    data() {
        return {
            vistaDepartmentArray: [],
            vistaLiabTemplateArray: [],
            selectedVistaDepartment: null,
            selectedVistaLiabTemplate: null,
            loadingVistaDepartmentAndLiabTemplate: false,
            selectedCustomerForVistaJob: null,
            selectedVistaJob: null,
            jobsFromVista: [],
            syncFromVistaStepTwo: false,
            fetchingVistaJobs: false,
            syncedOtherCompanyContact: null,
            updateCustomerContactInfo: false,
            customJobNumber: null,
            pushCustomerToVista: false,
            selectedVistaJobForChangeOrders: null,
            selectedVistaChangeOrder: null,
            jobChangeOrders: [],
            selectedProjectChangeOrderIndex: null,
            vistaLoading: false,
            createWorkOrder : false,
            workOrderType: {id:'customer', label:'Customer', $isDisabled: false},
            workOrderTypes: [{id:'job', label:'Job', $isDisabled: true},{id:'customer', label:'Customer', $isDisabled: false}],
            projectContacts: [],
            projectContactSelected: null,
            checkJobChangeOrdersSMContact: false,
            checkNoSMCustomerFound: false,
            allSMServiceSites:[],
            selectedServiceSite: null,
            checkJobForAllServiceSites: true,
            checkJobForAllServiceSiteForContact: false,
            updateProjectServiceSiteCheckBox: false,
            arCustomersVista: [],
            arCustomerVistaSelected: null,
            isARCustomerLoading: false,
            searchARCustomerQuery: '',
            smCustomerLogGenerate: false,
            syncVistaWorkOrderCheck: false,
            allSMWorkOrders:[],
            selectedWorkOrder: null,
            checkJobForAllWorkOrders: true,
            checkJobForAllWorkOrdersForContact: false,
            syncServiceSiteWithOutWorkOrder: false,
            syncContractFromVistaStepTwo: false,
            fetchingVistaContracts: false,
            contractsFromVista: [],
            selectedVistaContract: null,
            selectedVistaContractForChangeOrders: null,
            selectedConnection: null,
            erpConnectionId: null,
            syncingFromVista: false,
            syncingVistaContract: false,
            syncingVistaServiceSite: false,
            syncingSMWorkOrder: false,
            selectedVistaAction: null, // Track action: "connect", "sync", "update"
            vistaErrorMessage: "", // Store validation errors
            erpConnectionError: "The disabled instances do not have this automatic trigger set. To push to other instances, click cancel and manually push the project from the Vista dropdown menu.",
            loadingVistaData: false,
            vistaProjectConnectionData: {
                hasVistaProjectMapped: false,
                vistaProjectDirection: null,
                hasVistaCompanyMapped: false,
                hasVistaResidentialContactMapped: false,
                vistaJobNumberCustomFieldId: null,
                hasVistaChangeOrderMapped: false,
                vistaChangeOrderMappings: null,
                hasVistaWorkOrderMapped: false,
                vistaWorkOrderMappings: null,
                hasVistaWorkOrderFieldsMapped: false,
                hasVistaServiceSiteMapped: false,
                hasVistaServiceSiteFieldsMapped: false,
                checkCompanyContactMapping: true,
                hasVistaContractMapped: false,
                hasVistaContractFieldsMapped: false,
                hasVistaContractChangeOrderMapped: false,
                hasVistaContractChangeOrderFieldsMapped: false,
                vistaContractChangeOrderMappings: null,
                erpSyncSettingSalesStatusId: null,
                erpSyncSettingWorkOrderSalesStatusId: null,
            },
            vistaWorkOrderToolTip: '',
            vistaContractToolTip: '',
            vistaServiceSiteToolTip: '',
            syncingChangeOrderFromVista: false,
            vistaJobsConnectUpdateToolTip: '',
            vistaJobsSyncToolTip: '',
            matchingErpSyncSettings: null,
            vistaJobNumberId: null,
            vistaSelectedCustomerError: null,
        }
    },
    created() {
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
        this.debouncedContractFilterOptions = _.debounce(this.filterContracts, 500);
    },
    mounted() {
        // this.fetchVistaDepartmentAndLiabTemplate();
        $(document).ready(function() {
            // $('[data-toggle="tooltip"]').tooltip()
        //     // Initialize tooltip
            $('.custom-tooltip').tooltip();
        });
        if(this.erpConnections.length == 1){
            this.erpConnectionId = this.project.erp_connection_id ? this.project.erp_connection_id : this.erpConnections[0].id;
        }else{
            this.erpConnectionId = this.project.erp_connection_id ?? null;

        }
        if(this.erpConnectionId){
            this.fetchVistaProjectData(false);
        }

        if(this.vistaJobNumberCustomFieldId){
            this.vistaJobNumberId = this.vistaJobNumberCustomFieldId
        }
    },
    methods: {
        onDropdownOpened() {
            // Delay refresh slightly to avoid DOM focus/blur conflict
            this.$nextTick(() => {
                $('.custom-tooltip').tooltip('dispose');
                $('.custom-tooltip').tooltip({
                    trigger: 'hover',
                    placement: 'top',
                    container: 'body'
                });
            });
        },
        pushProjectToVista(action){
            let self = this;
            self.selectedVistaAction = action;
            if(this.erpConnectionId && this.vistaJobNumberId && !self.$parent.$refs.CustomFields.form[this.vistaJobNumberId]){
                self.getToast().fire({
                    type: 'error',
                    title: 'Vista Job # is required'
                });
            }else{

                let jobNumber = this.$parent.$refs.CustomFields.form[this.vistaJobNumberId] ?? null;
                this.pushOrUpdateProjectToVista(jobNumber);
            }
        },
        async fetchVistaProjectData(validateAction = true, connectionId = null) {
            if(connectionId){
                this.erpConnectionId = connectionId;
            }
            if (!this.selectedConnection && !this.erpConnectionId) {
                return;
            }
            this.vistaErrorMessage = "";
            this.loadingVistaData = true;
            this.vistaLoading = true;
            try {

                const response = await axios.post(route('api.vista.get-project-mappings-data'), {
                    connectionId: this.selectedConnection ? this.selectedConnection.id : (this.erpConnectionId ?? null)
                });

                if (response.data && response.data.status === "success") {
                    const vistaData = response.data;

                    // Update the state safely
                    this.$nextTick(()=>{

                        this.vistaProjectConnectionData = {
                            hasVistaProjectMapped: vistaData.hasVistaProjectMapped ?? false, // Check if mapping exists
                            vistaProjectDirection: vistaData.vistaProjectDirection ?? false, // Check if mapping exists
                            hasVistaCompanyMapped: vistaData.hasVistaCompanyMapped ?? false,
                            hasVistaResidentialContactMapped: vistaData.hasVistaResidentialContactMapped ?? false,
                            vistaJobNumberCustomFieldId: vistaData.vistaJobNumberCustomFieldId ?? null, // Extract from field JSON
                            hasVistaChangeOrderMapped: vistaData.hasVistaChangeOrderMapped ?? false,
                            vistaChangeOrderMappings: vistaData.vistaChangeOrderMappings ?? null,
                            hasVistaWorkOrderMapped: vistaData.hasVistaWorkOrderMapped ?? false,
                            vistaWorkOrderMappings: vistaData.vistaWorkOrderMappings ?? null,
                            hasVistaWorkOrderFieldsMapped: vistaData.hasVistaWorkOrderFieldsMapped ?? false,
                            hasVistaServiceSiteMapped: vistaData.hasVistaServiceSiteMapped ?? false,
                            hasVistaServiceSiteFieldsMapped: vistaData.hasVistaServiceSiteFieldsMapped ?? false,
                            checkCompanyContactMapping: vistaData.checkCompanyContactMapping ?? true,
                            hasVistaContractMapped: vistaData.hasVistaContractMapped ?? false,
                            hasVistaContractFieldsMapped: vistaData.hasVistaContractFieldsMapped ?? false,
                            hasVistaContractChangeOrderMapped: vistaData.hasVistaContractChangeOrderMapped ?? false,
                            hasVistaContractChangeOrderFieldsMapped: vistaData.hasVistaContractChangeOrderFieldsMapped ?? false,
                            vistaContractChangeOrderMappings: vistaData.vistaContractChangeOrderMappings ?? null,
                            erpSyncSettingSalesStatusId: vistaData.erpSyncSettingSalesStatusId ?? null,
                            erpSyncSettingWorkOrderSalesStatusId: vistaData.erpSyncSettingWorkOrderSalesStatusId ?? null,
                        };
                        this.vistaDepartmentArray = vistaData.department ?? [];
                        this.vistaLiabTemplateArray = vistaData.liabTemplates ?? [];

                        if(this.vistaProjectConnectionData.hasVistaResidentialContactMapped && this.vistaProjectConnectionData.hasVistaCompanyMapped){
                            this.pushCustomerToVista = true;
                        }
                        if(this.vistaProjectConnectionData.vistaJobNumberCustomFieldId){
                            this.vistaJobNumberId = this.vistaProjectConnectionData.vistaJobNumberCustomFieldId;
                            if(this.$parent.$refs.CustomFields.form){
                                this.customJobNumber = this.$parent.$refs.CustomFields.form[this.vistaProjectConnectionData.vistaJobNumberCustomFieldId] ?? null;
                                Bus.$emit('vistaCustomJobNumberIdChanged', {
                                    vistaJobNumber: this.vistaProjectConnectionData.vistaJobNumberCustomFieldId,
                                    direction: this.vistaProjectConnectionData.vistaProjectDirection
                                })
                            }
                        }

                        Bus.$emit('vistaConnectionDataChanged',this.vistaProjectConnectionData);
                        if(validateAction){
                            this.validateVistaActions();
                        }
                        this.setVistaButtonTitles();
                    })
                } else {
                    this.resetVistaProjectData();
                }
            } catch (error) {
                this.resetVistaProjectData();
            }finally {
                this.loadingVistaData = false; // Stop Loader after API completes
                this.vistaLoading = false; // Stop Loader after API completes
            }
        },
        validateVistaActions() {
            this.vistaErrorMessage = "";
            if (!this.vistaProjectConnectionData.hasVistaProjectMapped) {
                this.vistaErrorMessage = "Please map or enable Project - Jobs in settings and try again";
                return;
            }

            if (this.vistaProjectConnectionData.vistaProjectDirection === "one-way-followup" && (this.selectedVistaAction === "connect" || this.selectedVistaAction === "update")) {
                this.vistaErrorMessage = "This module is not set to push from Followup. Please change the direction in the settings to connect or update.";
                return;
            }

            if((this.selectedVistaAction === "connect" || this.selectedVistaAction === "update") && this.vistaProjectConnectionData.vistaJobNumberCustomFieldId && !this.$parent.$refs.CustomFields.form[this.vistaProjectConnectionData.vistaJobNumberCustomFieldId]){
                this.vistaErrorMessage = 'Vista Job # is required ';
                return;
            }

            if (this.vistaProjectConnectionData.vistaProjectDirection === "one-way-third-party" && this.selectedVistaAction === "sync") {
                this.vistaErrorMessage = "This module is not set to sync from Vista. Please change the direction in settings to sync.";
                return;
            }

            if(!this.vistaProjectConnectionData.hasVistaContractMapped && this.selectedVistaAction === "sync-contract"){
                this.vistaErrorMessage = "Please map or enable Project - JC Contract in settings and try again";
                return;
            }else if(!this.vistaProjectConnectionData.hasVistaContractFieldsMapped && this.selectedVistaAction === 'sync-contract'){
                this.vistaErrorMessage = "Please map all mandatory fields for Project - JC Contract module in settings and try again";
                return;
            }

            if(this.selectedVistaAction === "sync-service-site" && !this.vistaProjectConnectionData.hasVistaServiceSiteMapped){
                this.vistaErrorMessage =  "Please map or enable Project - SM Service Site in settings and try again";
                return;
            }

            if(this.selectedVistaAction === "sync-service-site" && !this.vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped){
                this.vistaErrorMessage = "Please map all mandatory fields for Project - SM Service Site module in settings and try again";
                return;
            }

            if((this.selectedVistaAction === "create-sm-work-order"  || this.selectedVistaAction === "sync-sm-work-order")&& !this.vistaProjectConnectionData.hasVistaWorkOrderMapped){
                this.vistaErrorMessage = "Please map or enable Project - SM Work Order in settings and try again";
                return;
            }

            if((this.selectedVistaAction === "create-sm-work-order"  || this.selectedVistaAction === "sync-sm-work-order") && !this.vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped){
                this.vistaErrorMessage = "Please map all mandatory fields for Project - SM Work Order module in settings and try again";
                return;
            }

            if(this.syncingChangeOrderFromVista && !this.vistaProjectConnectionData.hasVistaChangeOrderMapped && !this.vistaProjectConnectionData.hasVistaContractChangeOrderFieldsMapped){
                this.vistaErrorMessage = "Please map or enable Project - Project Change Order in settings and try again";
                return;
            }
            if(this.syncingChangeOrderFromVista){
                if(this.vistaProjectConnectionData.hasVistaChangeOrderMapped && !this.vistaProjectConnectionData.vistaChangeOrderMappings){
                    this.vistaErrorMessage = "Please map all mandatory fields for Project - Change Orders module in settings and try again"
                }else if(this.vistaProjectConnectionData.hasVistaContractChangeOrderFieldsMapped && !this.vistaProjectConnectionData.vistaContractChangeOrderMappings){
                    this.vistaErrorMessage = "Please map all mandatory fields for  Project - JC Contract module in settings and try again"
                }
                return;
            }
        },
        /**
         * Resets Vista Project Data to prevent undefined states
         */
        resetVistaProjectData() {
            this.vistaProjectConnectionData = {
                hasVistaProjectMapped: false,
                vistaProjectDirection: null,
                hasVistaCompanyMapped: false,
                hasVistaResidentialContactMapped: false,
                vistaJobNumberCustomFieldId: null,
                hasVistaChangeOrderMapped: false,
                vistaChangeOrderMappings: null,
                hasVistaWorkOrderMapped: false,
                vistaWorkOrderMappings: null,
                hasVistaWorkOrderFieldsMapped: false,
                hasVistaServiceSiteMapped: false,
                hasVistaServiceSiteFieldsMapped: false,
                checkCompanyContactMapping: true,
                hasVistaContractMapped: false,
                hasVistaContractFieldsMapped: false,
                hasVistaContractChangeOrderMapped: false,
                hasVistaContractChangeOrderFieldsMapped: false,
                vistaContractChangeOrderMappings: null,
            };
        },
        pushWorkOrderToVistaModal(){
            let self = this;
            // if(!self.project.agave_project_no){
            //     $('.vista-project-loader').hide();
            //     self.closeVistaModal('createProjectForWorkOrderTypeModal');
            //     self.createWorkOrder = false;
            //     self.openVistaModal('createProjectForWorkOrderModal');
            // }else {
                if (self.workOrderType == null){
                    $('.vista-project-loader').hide();
                    self.getToast().fire({
                        type: 'error',
                        title: 'Please select work order type...'
                    });
                }

                if (self.workOrderType) {
                    if (self.workOrderType.id === 'job'){
                        self.closeVistaModal('createProjectForWorkOrderTypeModal');
                        self.pushVistaWorkOrderStore()
                    }
                }

                if (self.workOrderType) {
                    if (self.workOrderType.id === 'customer') {
                        self.closeVistaModal('createProjectForWorkOrderTypeModal');
                        self.openVistaModal('createProjectContactsForWorkOrderModal')
                    }
                }
            // }
        },

        pushWorkOrderWithServiceSiteToVista(){
            let self = this;
            if (self.workOrderType == null){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select work order type...'
                });
            }


            if (self.workOrderType) {
                if (self.workOrderType.id === 'customer') {
                    self.closeVistaModal('createProjectForWorkOrderTypeModal');
                    self.openVistaModal('createProjectContactsForWorkOrderModal')
                }
            }
        },

        getProjectContacts(){
            const self = this;
            axios.post(route('api.project.vista.project-all-contacts'),{
                project_id: self.project.id,
            }).then((res) =>{
                self.projectContacts = res.data.contacts;
            }).catch((err)=>{
                console.log('err',err)
            })
        },

        pushProjectContactToVista(){
            if (this.project.vista_work_order_customer_no && this.project.vista_service_site && this.project.vista_service_center && this.project.vista_service_site_description){
                this.pushVistaWorkOrderCustomerExistCreateStore();
            }
            if (this.projectContactSelected && this.projectContactSelected.vista_customer_no){
                this.checkJobChangeOrdersSMContact = true;
                this.fetchSMContactVista();
            }

            if(this.projectContactSelected && this.projectContactSelected.company.vista_customer_id && this.projectContactSelected.company.agave_customer_no){
                this.closeVistaModal('searchVRContactsForWorkOrderModal');
                this.openVistaModal('createProjectContactsForWorkOrderModal');
                let arCustomer = {
                    source_id: this.projectContactSelected.company.vista_customer_id,
                    name: this.projectContactSelected.company.name,
                }
                this.fetchSMContactVista(arCustomer);
            }else if (this.projectContactSelected && !this.projectContactSelected.vista_customer_no){
                this.openVistaModal('searchVRContactsForWorkOrderModal');
                this.closeVistaModal('createProjectContactsForWorkOrderModal');
            }
        },
        fetchSMContactVista(vistaCustomerFull = null){
            const self = this;
            self.checkJobChangeOrdersSMContact = true;
            self.checkNoSMCustomerFound = false;
            let vistaARCustomer = '';
            let vistaARCustomerName = '';
            if (vistaCustomerFull){
                self.smCustomerLogGenerate = true;
                vistaARCustomer = vistaCustomerFull.source_id;
                vistaARCustomerName = vistaCustomerFull.name;
            }else {
                vistaARCustomer = self.projectContactSelected.vista_customer_no;
            }

            axios.post(route('api.project.vista.check-corresponding-sm-customer'),{
                ar_customer: vistaARCustomer,
                ar_customer_name: vistaARCustomerName,
                projectId: self.project.id,
                selected_contact: self.projectContactSelected,
                sm_sustomer_log_generate: self.smCustomerLogGenerate,
                connectionId: self.erpConnectionId,
            }).then((res) =>{
                if (res.data.count == 0){
                    self.checkJobChangeOrdersSMContact = false;
                    self.smCustomerLogGenerate = false;
                    self.checkNoSMCustomerFound = true;
                }
                if (res.data.count > 0){
                    self.checkJobChangeOrdersSMContact = false;
                    self.smCustomerLogGenerate = false;
                    self.checkNoSMCustomerFound = false;
                    self.closeVistaModal('createProjectContactsForWorkOrderModal');

                    if (self.syncVistaWorkOrderCheck){
                        self.openVistaModal('createProjectForAllWorkOrdersModal');
                        self.fetchSMWorkOrders(vistaARCustomer);
                    }else{
                        self.openVistaModal('createProjectForAllServiceSitesModal');
                        self.fetchSMServiceSites(vistaARCustomer);
                    }
                }
            }).catch((err)=>{
                console.log('err',err)
            })
        },
        createSMWorkOrder(action, workOrderAutomaticErpSyncWithSalesStatus){
            this.selectedVistaAction = action;
            this.matchingErpSyncSettings = workOrderAutomaticErpSyncWithSalesStatus
            if(this.erpConnections.length > 1 && this.selectedConnection == null && !this.project.erp_connection_id){
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            this.openVistaModal('createProjectForWorkOrderTypeModal')
        },
        fetchSMServiceSites(vistaARCustomerValue = null) {
            const self = this;
            let vistaARCustomer = '';
            if (vistaARCustomerValue){
                vistaARCustomer = vistaARCustomerValue;
            }else {
                vistaARCustomer = self.projectContactSelected.vista_customer_no;
            }
            axios.post(route('api.project.vista.fetch-all-sm-service-sites'), {
                ar_customer: vistaARCustomer,
                connectionId: self.erpConnectionId,
            }).then((res) => {
                if (res.data.service_sites.length > 0){
                    self.allSMServiceSites = res.data.service_sites;
                    self.checkJobForAllServiceSites = false;
                }else {
                    self.checkJobForAllServiceSiteForContact = true;
                    self.checkJobForAllServiceSites = false;
                }

            }).catch((err) => {
                console.log('err', err)
            })
        },
        fetchSMWorkOrders(vistaARCustomerValue = null, pageNo = 1) {
            const self = this;
            let vistaARCustomer = '';
            if (vistaARCustomerValue){
                vistaARCustomer = vistaARCustomerValue;
            }else {
                vistaARCustomer = self.projectContactSelected.vista_customer_no;
            }
            axios.post(route('api.project.vista.fetch-all-sm-work-orders'), {
                ar_customer: vistaARCustomer,
                page: pageNo,
                connectionId: self.erpConnectionId,
            }).then((res) => {
                if (res.data.work_orders.length > 0){
                    self.allSMWorkOrders = [...self.allSMWorkOrders, ...res.data.work_orders];
                    if(res.data.has_more_results){
                        self.fetchSMWorkOrders(vistaARCustomer, pageNo+1)
                    }else{
                        self.checkJobForAllWorkOrders = false;
                    }
                }else {
                    self.checkJobForAllWorkOrdersForContact = true;
                    self.checkJobForAllWorkOrders = false;
                }

            }).catch((err) => {
                console.log('err', err)
            })
        },
        searchARCustomers: _.debounce(function (searchQuery) {
            const self = this;
            self.isARCustomerLoading = true;
            let payload = {
                search_query: searchQuery ? searchQuery : "",
                connectionId: this.erpConnectionId
            }
            if (searchQuery) {
                axios.post(route('api.project.vista.fetch-search-ar-customers'), payload).then((res) => {
                    if (res.data.ar_customers.length > 0){
                        self.arCustomersVista = res.data.ar_customers;
                        self.isARCustomerLoading = false;
                    }else {
                        self.isARCustomerLoading = false;
                    }

                }).catch((err) => {
                    console.log('err', err)
                })
            } else {
                self.isARCustomerLoading = false;
                self.arCustomersVista = [];
            }

        }, 600),

        linkARCustomerToSelectedContact(){
            const self = this;
            self.smCustomerLogGenerate = true;
            let payload = {
                ar_customer: self.arCustomerVistaSelected,
                selected_contact: self.projectContactSelected,
                projectId: self.project.id,
                connectionId: self.erpConnectionId,
            }
            axios.post(route('api.project.vista.linked-ar-customers-with-company-contact'), payload).then((res) => {
                self.getToast().fire({
                    type: 'success',
                    title: res.data.message
                });
                self.closeVistaModal('searchVRContactsForWorkOrderModal');
                self.openVistaModal('createProjectContactsForWorkOrderModal');
                self.fetchSMContactVista(self.arCustomerVistaSelected);

            }).catch((err) => {
                console.log('err', err)
            })
        },
        fetchVistaDepartmentAndLiabTemplate(){
            this.loadingVistaDepartmentAndLiabTemplate = false;
            axios.post(route('api.project.vista.get-department-and-liab-templates')).then((response) => {
                this.loadingVistaDepartmentAndLiabTemplate = true;
                this.vistaDepartmentArray = response.data.department;
                this.vistaLiabTemplateArray = response.data.liabTemplates;
            });
        },
        // openVistaDepartmentAndLiabTemplateModal(){
        //     $('#vistaDepartmentAndLiabTemplateModal').modal('show');
        //     this.fetchVistaDepartmentAndLiabTemplate();
        // },
        pushOrUpdateProjectToVista(jobNumber = null){
            if(jobNumber){
                this.customJobNumber = jobNumber;
            }
            if(this.erpConnections.length > 1 && this.selectedConnection == null && !this.project.erp_connection_id){
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');


            if(this.project.vista_project_no || this.project.agave_project_no){
                this.validateVistaActions()
                if(!this.vistaErrorMessage){
                    $('#updateVistaJobModal').modal('show');
                }

            }else{
                this.selectedCustomerForVistaJob = null;
                $('#vistaCustomerSelectionModal').modal('show');
            }
        },
        syncProjectFromVista(action){
            this.selectedVistaAction = action;
            if(!this.erpConnectionId && this.selectedConnection == null && !this.project.erp_connection_id){
                this.syncingFromVista = true;
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(this.project.agave_project_no){
                $('#syncVistaJobConfirmModal').modal('show');
            }else{
                $('#syncJobFromVistaModal').modal('show');
            }
        },
        syncProjectChangeOrdersFromVista(index){
            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');
            this.selectedProjectChangeOrderIndex = index;
            if(this.project.agave_project_no){
                this.fetchJobChangeOrders()
            }else{
                $('#syncJobFromVistaForChangeOrderModal').modal('show');
            }
        },
        syncProjectChangeOrdersFromVistaContract(index, agave_contract_id){
            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');
            this.selectedProjectChangeOrderIndex = index;
            if(agave_contract_id){
                this.syncChangeOrderFromContract(agave_contract_id)
            }else{
                $('#syncContractFromVistaForChangeOrderModal').modal('show');
            }
        },
        openVistaConnectionSelection(syncingChangeOrder, action = null, projectAutomaticErpSyncWithSalesStatus = null){
            this.selectedVistaAction = action
            this.matchingErpSyncSettings = projectAutomaticErpSyncWithSalesStatus

            $('#selectConnectionForVista').modal('show');
            this.syncingChangeOrderFromVista = syncingChangeOrder;
        },
        openVistaModal(modalId) {
            $('#'+modalId).modal('show');
            if(modalId === 'vistaCustomerSelectionModal'){
                this.selectedCustomerForVistaJob = null;
            }
            $('.vista-project-loader').show();
            // if(modalId === 'vistaDepartmentAndLiabTemplateModal'){
            //     this.fetchVistaDepartmentAndLiabTemplate();
            // }
        },
        closeVistaModal(modalId, isCancelled = false) {
            $('#'+modalId).modal('hide');
            this.checkJobChangeOrdersSMContact = false;
            this.checkNoSMCustomerFound = false;
            this.checkJobForAllServiceSites = true;
            this.checkJobForAllWorkOrders = true;
            this.checkJobForAllServiceSiteForContact = false;
            this.checkJobForAllWorkOrdersForContact = false;
            this.isARCustomerLoading = false;
            $('.vista-project-loader').hide();
            if(isCancelled && (modalId === 'vistaCustomerSelectionModal' || modalId === 'selectConnectionForVista')) {
                this.$emit('pushProjectCancelled');
                if(!this.project.erp_connection_id){
                    this.erpConnectionId = null;
                    this.selectedConnection = null;
                }
            }

            if(modalId === 'selectConnectionForVista'){
                // this.selectedConnection = null;
                this.selectedVistaAction = null;
                this.vistaErrorMessage = '';
            }
        },
        closeVistaDepartmentAndLiabTemplateModal(isCancelled = false){
            this.selectedVistaDepartment = null;
            this.selectedVistaLiabTemplate = null;
            this.selectedCustomerForVistaJob = null;
            $('#vistaDepartmentAndLiabTemplateModal').modal('hide');
            if(isCancelled) {
                this.$emit('pushProjectCancelled');
            }
        },
        pushToVista(){
            let self = this;
            if(self.selectedVistaDepartment == null || self.selectedVistaDepartment == ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select department'
                });
                return false;
            }

            if(self.selectedVistaLiabTemplate == null || self.selectedVistaLiabTemplate == ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select liability template'
                });
                return false;
            }

            let data = {
                contact: self.selectedCustomerForVistaJob,
                projectId: self.project.id,
                selectedVistaDepartment: self.selectedVistaDepartment,
                selectedVistaLiabTemplate: self.selectedVistaLiabTemplate,
                timeZone: self.getTimeZoneWithFormat(),
                updateCustomerContact: self.updateCustomerContactInfo,
                agaveCustomerId: self.syncedOtherCompanyContact ? self.syncedOtherCompanyContact.agave_customer_no : null,
                vistaCustomerId: self.syncedOtherCompanyContact ? self.syncedOtherCompanyContact.vista_customer_no : null,
                customJobNumber: self.customJobNumber,
                vistaJobNumberCustomFieldId: self.vistaProjectConnectionData.vistaJobNumberCustomFieldId,
                pushWithContact: self.pushCustomerToVista,
                createWorkOrder: self.createWorkOrder,
                connectionId: self.erpConnectionId

            };
            $('.vista-project-loader').show();
            self.loadingVistaDepartmentAndLiabTemplate = false;
            self.closeVistaDepartmentAndLiabTemplateModal();
            axios.post(route('api.project.vista.push-project-to-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                self.createWorkOrder = false;
               if(response.data.status == 'success'){
                   self.getToast().fire({
                       type: 'success',
                       title: response.data.message
                   });
                   setTimeout(() => {
                       window.location.reload();
                   }, 3000);
                   // if(self.erpPushProjectInitiatedBySalesStatus && self.vistaProjectConnectionData.erpSyncSettingWorkOrderSalesStatusId == self.vistaProjectConnectionData.erpSyncSettingSalesStatusId) {
                   //     self.$parent.pushWorkOrderToEnabledERP();
                   // }
                   // else {
                   //     setTimeout(() => {
                   //         window.location.reload();
                   //     }, 3000);
                   // }
               }else{
                   self.getToast().fire({
                       type: 'error',
                       title: response.data.message
                   });
               }
            });

        },
        updateJobOnVista(){
            let self = this;
            $('.vista-project-loader').show();
            axios.post(route('api.project.vista.update-project-to-vista'), {projectId: this.project.id, connectionId: this.erpConnectionId}).then((response) => {
                $('.vista-project-loader').hide();
               if(response.data.status == 'success'){
                   self.closeVistaModal('updateVistaJobModal');
                   self.getToast().fire({
                       type: 'success',
                       title: response.data.message
                   });
                   setTimeout(() => {
                        window.location.reload();
                   }, 3000)
               }else{
                   self.getToast().fire({
                       type: 'error',
                       title: response.data.message
                   });
               }
            });

        },
        onSyncVistaInput(value) {
            if (value.length >= 3) {
                this.fetchingVistaJobs = true;
                this.debouncedFilterOptions(value);
            }
        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.project.vista.search-job-from-vista'), {search: input, connectionId: this.erpConnectionId}).then((response) => {
                self.fetchingVistaJobs = false;
                if(response.data.status == 'success'){
                    self.jobsFromVista = response.data.vistaJobs;
                    self.jobsFromVista = self.jobsFromVista.map((job) => {
                        let label = job.number + ' | ' + job.name
                        if(job.source_data.data.MailAddress){
                            label = label + ' | ' + job.source_data.data.MailAddress
                        }
                        return {
                            ...job,
                            "label": label
                        }
                    })
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        onContractSyncVistaInput(value) {
            if (value.length >= 3) {
                this.fetchingVistaContracts = true;
                this.debouncedContractFilterOptions(value);
            }
        },
        filterContracts(input) {
            let self = this;
            axios.post(route('api.project.vista.search-contract-from-vista'), {search: input, connectionId: this.erpConnectionId}).then((response) => {
                self.fetchingVistaContracts = false;
                if(response.data.status == 'success'){
                    self.contractsFromVista = response.data.vistaContracts;
                    self.contractsFromVista = self.contractsFromVista.map((contract) => {
                        let label = contract.number + ' | ' + contract.name
                        return {
                            ...contract,
                            "label": label
                        }
                    })
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        syncContractFromVista(action){
            this.selectedVistaAction = action;
            this.syncingVistaContract = true;

            if(this.erpConnections.length > 1 && this.selectedConnection == null && !this.project.erp_connection_id){
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');


            if(this.project.agave_contract_id){
                $('#syncVistaContractConfirmModal').modal('show');
            }else{
                $('#syncContractFromVistaModal').modal('show');
            }
        },
        pullContractFromVista(){
            let self = this;
            $('.vista-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedVistaContract ? this.selectedVistaContract.project_id : null,
                agaveContractId: this.project.agave_contract_id ?? (this.selectedVistaContract? this.selectedVistaContract.id : null),
                connectionId: this.erpConnectionId
            }
            axios.post(route('api.project.vista.sync-contract-from-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                if(response.data.status == 'success'){

                    self.closeVistaModal('syncVistaContractConfirmModal');
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },
        pullJobFromVista(){
            let self = this;
            $('.vista-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedVistaJob ? this.selectedVistaJob.id : null,
                connectionId: this.erpConnectionId
            }
            axios.post(route('api.project.vista.sync-project-from-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                if(response.data.status == 'success'){

                    self.closeVistaModal('syncVistaJobConfirmModal');
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },

        linkJobForChangeOrdersFromVista(){
            let self = this;
            $('.vista-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedVistaJobForChangeOrders ? this.selectedVistaJobForChangeOrders.id : null,
                vistaJobId: this.selectedVistaJobForChangeOrders ? this.selectedVistaJobForChangeOrders.number : null,
                connectionId: this.erpConnectionId
            }

            axios.post(route('api.project.vista.link-project-from-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                self.jobChangeOrders = response.data;
                self.closeVistaModal('syncJobFromVistaForChangeOrderModal');
                self.openVistaModal('syncVistaChangeOrderModal');
            });
        },
        syncChangeOrderFromContract(agave_contract_id = null){
            let self = this;
            $('.vista-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveContractId: this.selectedVistaContractForChangeOrders ? this.selectedVistaContractForChangeOrders.id : (agave_contract_id? agave_contract_id : null),
                selectedProjectChangeOrderIndex: this.selectedProjectChangeOrderIndex ?? null,
                projectChangeOrder: this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null,
                connectionId: this.erpConnectionId
            }

            axios.post(route('api.project.vista.sync-project-change-order-from-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                self.closeVistaModal('updateVistaSyncedContractChangeOrderConfirmModal');
                if(response.data.status == 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        fetchJobChangeOrders(){
            let self = this;
            $('.vista-project-loader').show();
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedVistaJobForChangeOrders ? this.selectedVistaJobForChangeOrders.id : null,
                vistaJobId: this.project ? this.project.vista_project_no : null,
                connectionId: this.erpConnectionId
            }
            self.getToast().fire({
                type: 'success',
                title: "Fetching change orders from Vista"
            });
            axios.post(route('api.project.vista.get-project-change-orders-from-vista'), data).then((response) => {
                $('.vista-project-loader').hide();
                self.jobChangeOrders = response.data;
                self.openVistaModal('syncVistaChangeOrderModal')

            });
        },
        syncJobChangeOrder(){
            let self = this;
            $('.vista-project-loader').show();

            let data = {
                projectId: this.project.id,
                selectedChangeOrder: this.selectedVistaChangeOrder ?? null,
                selectedProjectChangeOrderIndex: this.selectedProjectChangeOrderIndex ?? null,
                projectChangeOrder: this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null,
                connectionId: this.erpConnectionId
            }

            axios.post(route('api.project.vista.sync-project-change-orders-from-vista'), JSON.stringify(data)).then((response) => {
                $('.vista-project-loader').hide();
                self.closeVistaModal('updateVistaSyncedChangeOrderConfirmModal');
                if(response.data.status == 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            });
        },
        getTimeZoneWithFormat() {
            const now = new Date();
            const offsetMinutes = now.getTimezoneOffset();
            const offsetHours = Math.abs(offsetMinutes) / 60;
            const offsetSign = offsetMinutes < 0 ? '+' : '-';
            const timeZoneOptions = { timeZoneName: 'long' };
            const timeZoneFormat = new Intl.DateTimeFormat('en-US', timeZoneOptions);
            const timeZone = timeZoneFormat.format(new Date());
            const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formattedOffset = `UTC${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(Math.abs(offsetMinutes % 60)).padStart(2, '0')}`;
            const formattedTimeZone = `(${formattedOffset}) ${timeZone}`;

            return formattedTimeZone;
        },
        checkCustomerVistaStatus(){

            if((this.selectedCustomerForVistaJob.is_contact_residential && !this.vistaProjectConnectionData.hasVistaResidentialContactMapped) ||
                (!this.selectedCustomerForVistaJob.is_contact_residential && !this.vistaProjectConnectionData.hasVistaCompanyMapped)){
                this.openVistaModal('pushProjectWithOutCompanyModal')
            }else{
                this.pushCustomerToVista = false;
                this.proceedPushToVista();
            }
        },
        pushProjectWithoutCustomer(val){
            this.pushCustomerToVista = val;
            this.proceedPushToVista();
        },
        proceedPushToVista(){
            this.updateCustomerContactInfo = false;
            this.syncedOtherCompanyContact = null;
            this.$nextTick( async ()=>{
                if(this.selectedCustomerForVistaJob.is_contact_residential){
                    this.openVistaModal('vistaDepartmentAndLiabTemplateModal');
                }else{
                    if(this.selectedCustomerForVistaJob.vista_customer_no){
                        this.openVistaModal('vistaDepartmentAndLiabTemplateModal');
                    }else{
                        this.checkIfCompanyIsSyncedWithVista(this.selectedCustomerForVistaJob.company_id)
                    }
                }

            })
        },
        checkIfCompanyIsSyncedWithVista(companyId){
            this.updateCustomerContactInfo = false;
            axios.post(route('api.company.check-synced-with-vista'), {companyId: companyId, connectionId: this.erpConnectionId}).then((response) => {
                if(response.data.status == 'success' && response.data.isCompanySynced && response.data.contact && response.data.contact.id != this.selectedCustomerForVistaJob.id){
                    this.syncedOtherCompanyContact = response.data.contact;
                    this.openVistaModal('updateVistaSyncedCustomerConfirmModal');
                }else{
                    this.openVistaModal('vistaDepartmentAndLiabTemplateModal');
                }
            });
        },
        updateSyncedCustomerOnVista(confirmation){
            this.updateCustomerContactInfo = confirmation;
            this.closeVistaModal('updateVistaSyncedCustomerConfirmModal');
            this.openVistaModal('vistaDepartmentAndLiabTemplateModal');
        },
        syncProjectVistaInvoice(){
            this.$parent.$refs.VistaIncomeCost.syncProjectVistaInvoice(true);
        },

        pushVistaWorkOrderStore() {
            let self = this;
            $('.vista-project-loader').show();
            if(this.project.agave_project_no){
                let data = {
                    projectId: this.project.id,
                    work_order_type: 'Job',
                    connectionId: this.erpConnectionId
                }

                axios.post(route('api.vista.push-vista-work-order'), data).then((response) => {
                    $('.vista-project-loader').hide();
                    if(response.data.status == 'success'){
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000)
                    }else{
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });
            }else{
                self.createWorkOrder = false;
                self.openVistaModal('createProjectForWorkOrderModal');
            }

        },
        pushVistaWorkOrderCustomerExistCreateStore() {
            let self = this;
            $('.vista-project-loader').show();
            this.closeVistaModal('createProjectContactsForWorkOrderModal');
            let data = {
                projectId: this.project.id,
                work_order_type: this.workOrderType.label,
                ar_customer: this.project.vista_work_order_customer_no,
                service_site: this.project.vista_service_site,
                service_site_description: this.project.vista_service_site_description,
                service_center: this.project.vista_service_center,
                connectionId: this.erpConnectionId
            }
                axios.post(route('api.vista.push-vista-work-order-exist'), data).then((response) => {

                    if (response.data.status == 'success') {
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });

                        $('.vista-project-loader').hide();
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000)

                    } else {
                        $('.vista-project-loader').hide();
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });

        },
        pushVistaWorkOrderCustomerServiceStore() {
            let self = this;
            $('.vista-project-loader').show();
            if (this.selectedServiceSite == null){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select service site...'
                });
            }

            axios.post(route('api.contact.get-contact-for-vista'), {contactId: this.projectContactSelected.id}).then((response) => {
               this.projectContactSelected = response;
            });

            let arCustomer = '';
            if (this.projectContactSelected.company.vista_customer_id){
                arCustomer = this.projectContactSelected.company.vista_customer_id;
            }else if (this.projectContactSelected.vista_customer_no) {
                arCustomer = this.projectContactSelected.vista_customer_no;
            } else {
                arCustomer = this.arCustomerVistaSelected.source_id;
            }
            let checkContactFieldMapped = '';

            if(!this.vistaProjectConnectionData.checkCompanyContactMapping){
                checkContactFieldMapped = 'no'
            }

            let data = {
                projectId: this.project.id,
                work_order_type: this.workOrderType.label,
                selected_contact: this.projectContactSelected.id,
                ar_customer: arCustomer,
                sync_service_site: this.updateProjectServiceSiteCheckBox,
                sm_customer: this.selectedServiceSite.Customer,
                service_site: this.selectedServiceSite.ServiceSite,
                service_site_description: this.selectedServiceSite.Description,
                service_center: this.selectedServiceSite.DefaultServiceCenter,
                service_site_exists: false,
                isContactFieldMapped: checkContactFieldMapped,
                connectionId: this.erpConnectionId
            }
            if (this.syncServiceSiteWithOutWorkOrder) {
                this.syncProjectToServiceSite(data);
            } else {
                axios.post(route('api.vista.push-vista-work-order'), data).then((response) => {

                    if (response.data.status == 'success') {
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        if (this.updateProjectServiceSiteCheckBox) {
                            this.syncProjectToServiceSite(data);
                        } else {
                            $('.vista-project-loader').hide();
                            setTimeout(() => {
                                window.location.reload();
                            }, 3000)
                        }
                    } else {
                        $('.vista-project-loader').hide();
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });
            }
        },
        updateVistaWorkOrder(){
            let self = this;
            $('.vista-project-loader').show();
            if(!this.project.agave_project_no && (this.project.vista_work_order_type == 'Job')){
                self.getToast().fire({
                    type: 'error',
                    title: 'Project is not linked to any Vista job'
                });
            }else{
                let data = {
                    projectId: this.project.id,
                    connectionId: this.erpConnectionId
                }

                axios.post(route('api.vista.update-vista-work-order'), data).then((response) => {
                    $('.vista-project-loader').hide();
                    if(response.data.status == 'success'){
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000)
                    }else{
                        self.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }

                });
            }
        },
        syncVistaServiceSite(action){

            this.selectedVistaAction = action;
            this.syncingVistaServiceSite = true;
            if(this.erpConnections.length > 1 && this.selectedConnection == null && !this.project.erp_connection_id){
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            if (!this.project.vista_service_site){
                this.syncServiceSiteWithOutWorkOrder = true;
                this.openVistaModal('createProjectContactsForWorkOrderModal');
            }else{
                this.openVistaModal('syncProjectForServiceSiteModal');
            }
        },
        syncVistaWorkOrder(){
            this.selectedVistaAction = 'sync-sm-work-order';
            this.syncingSMWorkOrder = true;

            if(this.erpConnections.length > 1 && this.selectedConnection == null && !this.project.erp_connection_id){
                this.openVistaModal('selectConnectionForVista');
                return;
            }

            if(!this.erpConnectionId){
                this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            }
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            this.syncVistaWorkOrderCheck = true;
            if (this.project.agave_work_order_no && this.project.vista_work_order_no){
                this.openVistaModal('syncProjectForWorkOrderExistModal');
            }else{
                this.openVistaModal('createProjectContactsForWorkOrderModal');
            }
        },
        syncVistaWorkOrderCustomerServiceStore(){

            if (this.selectedWorkOrder == null){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select work order...'
                });
            }
            this.openVistaModal('syncProjectForWorkOrderModal');
        },
        syncProjectToServiceSite(data = null){
            $('.vista-project-loader').show();
            let dataArray = data;
            if (!data){
                dataArray = {
                    projectId: this.project.id,
                    service_site: this.project.vista_service_site,
                    service_site_exists: true,
                    connectionId: this.erpConnectionId,
                }
            }
            axios.post(route('api.vista.sync-vista-service-site'), dataArray).then((response) => {
                $('.vista-project-loader').hide();
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            });
        },
        syncProjectToWorkOrder(data = null){
            $('.vista-project-loader').show();
            let dataArray = data;
            if (this.updateProjectServiceSiteCheckBox){
                if (this.selectedWorkOrder.source_data.data.ServiceSite  == null){
                    this.getToast().fire({
                        type: 'error',
                        title: 'This work order has no service site info we are unable to sync service site info with project.'
                    });
                }
            }

            axios.post(route('api.contact.get-contact-for-vista'), {contactId: this.projectContactSelected.id}).then((response) => {
                this.projectContactSelected = response;
            });

            let arCustomer = '';
            if (this.projectContactSelected.company.vista_customer_id){
                arCustomer = this.projectContactSelected.company.vista_customer_id;
            }else if (this.projectContactSelected.vista_customer_no) {
                arCustomer = this.projectContactSelected.vista_customer_no;
            } else {
                arCustomer = this.arCustomerVistaSelected.source_id;
            }

            dataArray = {
                projectId: this.project.id,
                selected_contact: this.projectContactSelected.id,
                ar_customer: arCustomer,
                sync_service_site: this.updateProjectServiceSiteCheckBox,
                select_work_order: this.selectedWorkOrder,
                connectionId: this.erpConnectionId
            }

            axios.post(route('api.vista.sync-vista-work-order'), dataArray).then((response) => {
                $('.vista-project-loader').hide();
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    if (this.updateProjectServiceSiteCheckBox && this.selectedWorkOrder.source_data.data.ServiceSite) {
                        this.syncProjectToServiceSite(dataArray);
                    } else {
                        $('.vista-project-loader').hide();
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000)
                    }
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            });
        },
        syncProjectToWorkOrderExist(data = null){
            $('.vista-project-loader').show();
            let dataArray = data;
            dataArray = {
                projectId: this.project.id,
                connectionId: this.erpConnectionId
            }

            axios.post(route('api.vista.sync-vista-work-order-exist'), dataArray).then((response) => {
                $('.vista-project-loader').hide();
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                        $('.vista-project-loader').hide();
                        setTimeout(() => {
                            window.location.reload();
                        }, 3000)
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            });
        },
        selectConnectionBeforeSync() {
            this.syncingFromVista = true;
            this.closeVistaModal("syncVistaCustomerModal");
            this.openVistaModal("selectConnectionForVista");
        },
        handleVistaSyncSelection() {
            if (!this.selectedConnection) return;

            this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            if(this.syncingFromVista){
                if(this.project.agave_project_no){
                    $('#syncVistaJobConfirmModal').modal('show');
                }else{
                    $('#syncJobFromVistaModal').modal('show');
                }

            }else if(this.syncingVistaContract){
                if(this.project.agave_contract_id){
                    $('#syncVistaContractConfirmModal').modal('show');
                }else{
                    $('#syncContractFromVistaModal').modal('show');
                }
            }else if(this.syncingVistaServiceSite){
                if (!this.project.vista_service_site){
                    this.syncServiceSiteWithOutWorkOrder = true;
                    this.openVistaModal('createProjectContactsForWorkOrderModal');
                }else{
                    this.openVistaModal('syncProjectForServiceSiteModal');
                }
            }else if(this.syncingSMWorkOrder){
                this.syncVistaWorkOrderCheck = true;
                if (this.project.agave_work_order_no && this.project.vista_work_order_no){
                    this.openVistaModal('syncProjectForWorkOrderExistModal');
                }else{
                    this.openVistaModal('createProjectContactsForWorkOrderModal');
                }
            }
        },
        handleVistaContractSyncSelection() {
            if (!this.selectedConnection) return;

            this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            if(this.project.agave_contract_id){
                $('#syncVistaContractConfirmModal').modal('show');
            }else{
                $('#syncContractFromVistaModal').modal('show');
            }
        },
        handleVistaSyncServiceSiteSelection() {
            if (!this.selectedConnection) return;

            this.erpConnectionId = this.selectedConnection?.id ?? this.project.erp_connection_id;
            this.selectedConnection = null;
            this.closeVistaModal('selectConnectionForVista');

            if (!this.project.vista_service_site){
                this.syncServiceSiteWithOutWorkOrder = true;
                this.openVistaModal('createProjectContactsForWorkOrderModal');
            }else{
                this.openVistaModal('syncProjectForServiceSiteModal');
            }
        },
        setVistaButtonTitles() {
            if(!this.vistaProjectConnectionData.hasVistaWorkOrderMapped){
                this.vistaWorkOrderToolTip = "Please map Project - Work Order in settings and try again";
            }else if(!this.vistaProjectConnectionData.hasVistaWorkOrderFieldsMapped){
                this.vistaWorkOrderToolTip = "Please map all mandatory fields for Project - Work Order module in settings and try again";
            }else{
                this.vistaWorkOrderToolTip = "";
            }

            if(!this.vistaProjectConnectionData.hasVistaContractMapped){
                this.vistaContractToolTip = "Please map Project - JC Contract in settings and try again";
            }else if(!this.vistaProjectConnectionData.hasVistaContractFieldsMapped){
                this.vistaContractToolTip = "Please map all mandatory fields for Project - JC Contract module in settings and try again";
            }else{
                this.vistaContractToolTip = "";
            }

            if(!this.vistaProjectConnectionData.hasVistaServiceSiteMapped){
                this.vistaServiceSiteToolTip = "Please map Project - SM Service Site in settings and try again";
            }else if(!this.vistaProjectConnectionData.hasVistaServiceSiteFieldsMapped){
                this.vistaServiceSiteToolTip = "Please map all mandatory fields for Project - SM Service Site module in settings and try again";
            }else{
                this.vistaServiceSiteToolTip = "";
            }

            if(!this.vistaProjectConnectionData.hasVistaProjectMapped){
                this.vistaJobsConnectUpdateToolTip = "Please map Project - Jobs in settings and try again";
                this.vistaJobsSyncToolTip = "Please map Project - Jobs in settings and try again";
            }else if(this.vistaProjectConnectionData.vistaProjectDirection === 'one-way-followup'){
                this.vistaJobsConnectUpdateToolTip = "This module is not set to push from Followup. Please change the direction in settings to connect or update.";
            }else if(this.vistaProjectConnectionData.vistaProjectDirection === 'one-way-third-party'){
                this.vistaJobsSyncToolTip = "This module is not set to sync from Vista. Please change the direction in settings to sync.";
            }else{
                this.vistaJobsConnectUpdateToolTip = "";
                this.vistaJobsSyncToolTip = "";
            }
            this.vistaLoading = false;
        },
    },
    computed: {
        allowedErpConnectionIds() {
            return this.matchingErpSyncSettings?.map(s => s.erp_connection_id) || [];
        },

        processedErpConnections() {
            return this.erpConnections.map(option => ({
                ...option,
                $isDisabled: this.erpPushProjectInitiatedBySalesStatus ? !this.allowedErpConnectionIds.includes(option.id) : false
            }));
        },
        vistaConnectionSelectionModalTitle(){
            if(this.erpPushProjectInitiatedBySalesStatus) {
                return 'Select Connection based on current Sync Settings'
            }else{
                return 'Select Connection';
            }
        },
        vistaCustomerSelectionModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Company/Contact ('+match.name+')' : 'Select Company/Contact';
        },
        vistaDepartmentAndLiabTemplateModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista Department & Liability Template ('+match.name+')' : 'Select Vista Department & Liability Template';
        },
        updateVistaJobModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - This will over-write the info of the Synced Vista Job ('+match.name+')' : 'WARNING! - This will over-write the info of the Synced Vista Job.';
        },
        syncVistaJobConfirmModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - This will over-write some of the Project fields ('+match.name+')' : 'WARNING! - This will over-write some of the Project fields';
        },
        syncJobFromVistaModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            if(!this.syncFromVistaStepTwo){
                return match ? 'This project is not synced with a Vista Job ('+match.name+')' : 'This project is not synced with a Vista Job';
            }else{
                return match ? 'WARNING! - This will over-write some of the Project fields ('+match.name+')' : 'WARNING! - This will over-write some of the Project fields';
            }
        },
        updateVistaSyncedCustomerConfirmModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - This will over-write the info of the Synced Vista Customer ('+match.name+')' : 'WARNING! - This will over-write the info of the Synced Vista Customer';
        },
        syncJobFromVistaForChangeOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista Job ('+match.name+')' : 'Select Vista Job';
        },
        syncVistaChangeOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista Change Order ('+match.name+')' : 'Select Vista Change Order';
        },
        updateVistaSyncedChangeOrderConfirmModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - Replace Change Order fields with data from Vista? ('+match.name+')' : 'WARNING! - Replace Change Order fields with data from Vista?';
        },
        createProjectForWorkOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Create a Job on Vista ('+match.name+')' : 'Create a Job on Vista';
        },
        createProjectForWorkOrderTypeModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select work order type ('+match.name+')' : 'Select work order type';
        },
        createProjectContactsForWorkOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            if(this.checkNoSMCustomerFound && !this.checkJobChangeOrdersSMContact){
                return match ? 'SM Customer not found ('+match.name+')' : 'SM Customer not found';
            }else{
                return match ? 'Select Company/Contact ('+match.name+')' : 'Select Company/Contact';
            }
        },
        createProjectForAllServiceSitesModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Service Site ('+match.name+')' : 'Select Service Site';
        },
        createProjectForAllWorkOrdersModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista Work Order ('+match.name+')' : 'Select Vista Work Order';
        },
        searchVRContactsForWorkOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista AR Customer ('+match.name+')' : 'Select Vista AR Customer';
        },
        syncProjectForServiceSiteModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Sync From Service Site ('+match.name+')' : 'Sync From Service Site';
        },
        syncProjectForWorkOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Link Work Order & Update Project ('+match.name+')' : 'Link Work Order & Update Project';
        },
        syncProjectForWorkOrderExistModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Update Project? ('+match.name+')' : 'Update Project?';
        },
        syncContractFromVistaModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            if(!this.syncContractFromVistaStepTwo){
                return match ? 'This project is not synced with a Vista Contract ('+match.name+')' : 'This project is not synced with a Vista Contract';
            }else{
                return match ? 'WARNING! - This will over-write some of the Project fields ('+match.name+')' : 'WARNING! - This will over-write some of the Project fields';
            }
        },
        syncVistaContractConfirmModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - This will over-write some of the Project fields ('+match.name+')' : 'WARNING! - This will over-write some of the Project fields';
        },
        syncContractFromVistaForChangeOrderModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'Select Vista Contract ('+match.name+')' : 'Select Vista Contract';
        },
        updateVistaSyncedContractChangeOrderConfirmModalTitle(){
            const match = this.erpConnections.find(
                conn => conn.id === this.erpConnectionId
            );
            return match ? 'WARNING! - Replace Change Order fields with data from Vista? ('+match.name+')' : 'WARNING! - Replace Change Order fields with data from Vista?';
        }
        // vistaContractToolTip() {
        //     if(!this.vistaProjectConnectionData.hasVistaContractMapped){
        //         return 'Please map Project & JC Contract in ERP settings and try again';
        //     }else if(!this.vistaProjectConnectionData.hasVistaContractFieldsMapped){
        //         return 'Please map all mandatory fields in Project <> JC Contract mapping and try again';
        //     }else{
        //         return '';
        //     }
        // },

        // vistaServiceSiteToolTip() {
        //     if(!this.hasVistaServiceSiteMapped){
        //         return 'Map Followup Project Module to Vista SM Service Site module in the ERP settings and try again';
        //     }else if(!this.hasVistaServiceSiteFieldsMapped){
        //         return 'Please map all mandatory fields in Project <> Service Site mapping and try again';
        //     }
        //     // else if(!this.project.agave_work_order_no){
        //     //     return 'The project is not connected to a work order. Push a work order and then try again.';
        //     // }
        //     else{
        //         return '';
        //     }
        // },

    }

}
</script>
<style scoped>
.custom-tooltip{
    pointer-events: all !important;
}
.vista-button-disabled{
    cursor: not-allowed !important;
}
</style>
